import { render, staticRenderFns } from "./Manifest.vue?vue&type=template&id=595070c2&scoped=true"
import script from "./Manifest.vue?vue&type=script&lang=js"
export * from "./Manifest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "595070c2",
  null
  
)

export default component.exports